import { alpha } from '@material-ui/core';
import { Color, ColorDynamic } from "../theme/Color.js";
export function overridePagination(theme) {
  var props = {};
  var mode = theme.palette.type;
  var color = mode === 'dark' ? alpha(Color.White, 0.08) : ColorDynamic.Silver200;
  var overrides = {
    root: {
      color: ColorDynamic.Dark500
    },
    page: {
      '&:hover': {
        backgroundColor: color
      },
      '&$focusVisible': {
        borderRadius: 4,
        backgroundColor: ColorDynamic.White,
        border: "1px solid ".concat(ColorDynamic.Blue30)
      },
      '&$selected': {
        backgroundColor: ColorDynamic.Silver400,
        '&:hover, &$focusVisible': {
          backgroundColor: ColorDynamic.Silver500
        },
        '&$disabled': {
          color: ColorDynamic.Dark100,
          backgroundColor: ColorDynamic.Silver400
        }
      },
      '&$disabled': {
        opacity: undefined,
        color: ColorDynamic.Dark100
      }
    }
  };

  // Remove `Object.assign` after official release of `PaginationItem`.
  Object.assign(theme.props, {
    MuiPaginationItem: props
  });
  Object.assign(theme.overrides, {
    MuiPaginationItem: overrides
  });
}